import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ProgressStyles from './Progress.styles';

export const Progress = ({
  classes,
  children,
  isSubmitting,
  className,
  ...props
}) => {
  const buttonType = props.variant;

  return (
    <div className={classes.root}>
      <Button
        {...props}
        classes={{
          disabled: classes.disabled,
          label: classes.label
        }}
        className={classnames(className, {
          [classes.noBorder]: isSubmitting
        })}
      >
        <span className={classnames({ [classes.hideText]: isSubmitting })}>
          {children}
        </span>
        {isSubmitting && (
          <div
            className={classnames(classes.progressContainer, {
              [classes.progressContainerContained]: buttonType === 'contained',
              [classes.progressContainerOutlined]: buttonType === 'outlined'
            })}
          >
            <CircularProgress
              className={classnames(classes.progressIcon, {
                [classes.progressIconContained]: buttonType === 'contained'
              })}
            />
          </div>
        )}
      </Button>
    </div>
  );
};

export default withStyles(ProgressStyles)(Progress);
